module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": _vm.name
    },
    on: {
      "change": _vm.change
    }
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.id
      }
    }, [_vm._v(_vm._s(cat.description))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2848d103"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoriesSelect.vue
// module id = 159
// module chunks = 1